
const LoadMoreButton = ({ onLoadMore, loading, hasMore }) => {
  return (
    <div className="text-center my-4">
      {hasMore ? (
        <button
          className="btn btn-outline-primary"
          onClick={onLoadMore}
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </>
          ) : (
            "Load More"
          )}
        </button>
      ) : (
        <p className="text-muted">No more items to load.</p>
      )}
    </div>
  );
};

export default LoadMoreButton;
